export default __webpack_public_path__ + "static/media/historic-site.e40b268d.svg";